<template lang="html">
  <div v-bind:class="['ChunkSiblingElement', {current: current}]">
    <router-link v-if="!current" :to="'/clip/' + chunk.id" :title="title">
      <p>{{chunk.title}}</p>
    </router-link>
    <p v-else>{{chunk.title}}</p>
    <p class="time">{{title}}</p>
  </div>
</template>

<script>
export default {
  name: 'ChunkSiblingElement',
  props: ['chunk', 'isTextOnly', 'current'],
  computed: {
    title() {
      let title = ""
      if (this.chunk.end > this.chunk.start) {
        title = this.stringTime(this.chunk.end - this.chunk.start) + " @ " + this.minSeconds(this.chunk.start)
      } else {
        title = "@ " + this.minSeconds(this.chunk.start)
      }
      return title
    }
  },
  methods: {
    minSeconds(seconds) {
      let reminder = seconds%60
      if (reminder < 10) {
        reminder = "0" + reminder
      }
      return Math.floor(seconds/60) + ":" + reminder
    },
    stringTime(seconds) {
      let string = ""
      if (seconds <= 60) {
        string = seconds + "s"
      } else {
        string = Math.floor(seconds/60) + "m " + seconds%60 + "s"
      }
      return string
    }
  }
}
</script>

<style lang="css" scoped>
.ChunkSiblingElement {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: auto;
  min-width: 6rem;
  border-radius: 7px;
  padding: 0.7rem 2rem 0.7rem 1.4rem;
  margin: 0 1rem 1rem 1rem;
  background-color: rgb(30, 38, 51);
  color: rgb(186, 181, 163);
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
}
a, a:visited {
  color: rgb(186, 181, 163);
}
a:hover {
  color: rgb(226, 93, 93);
}
p {
  margin: 0;
}
.current {
  position: sticky;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgb(232, 162, 57);
  color: #000;
  margin-left: 0;
  padding-left: 2.4rem;
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.9);
}
.time {
  margin-top: 0.7rem;
  font-size: 18px;
  font-style: italic;
}
:last-of-type {
  margin-bottom: 0;
}

</style>
